import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft, FaSearch, FaCalendarAlt, FaFileInvoice } from "react-icons/fa";

import styles from "./OrdersPage.module.scss";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchItemsList,
  fetchOrdersListData,
  fetchDeliveriesListData,
  fetchProcessesList,
  getItems,
  getOrders,
  getParties,
  getProcesses,
  getTotalOrders,
  fetchPartiesList,
  getIsOrderModalOpen,
  getEditOrder,
  setEditOrder,
  getTotalAmount,
  getIsOrderPhotoModalOpen,
  getDeliveries,
  getTotalDeliveries,
  getTotalDeliveryAmount,
  getIsDeliveryModalOpen,
  getIsDeliveryHistoryModalOpen,
  getEditDelivery,
  setEditDelivery,
  toggleDeliveryModal,
} from "../../features/orders/ordersSlice";
import Pagination from "../../components/pagination";
import { toast } from "react-toastify";
import { selectStyles, toastStyles } from "../../static/styles";
import { DELETE, GET, PUT } from "../../services/axios.service";
import { Controller, useForm } from "react-hook-form";
import OrderList from "../../components/orders/OrderList";
import DeliveryList from "../../components/orders/DeliveryList";
import { IFormInput, IDeliveryFormInput, IInvoiceFilterInput, OptionsProps, OrdersProps } from "../../types/orders";
import OrdersFormModal from "../../components/orders/OrdersFormModal";
import DeliveryFormModal from "../../components/orders/DeliveryFormModal";
import DeliveryHistoryModal from "../../components/orders/DeliveryHistoryModal";
import PhotoModel from "../../components/orders/PhotoModel";
import moment from "moment";

const OrdersPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const orders = useAppSelector(getOrders);
  const totalOrders = useAppSelector(getTotalOrders);
  const totalAmount = useAppSelector(getTotalAmount);
  const deliveries = useAppSelector(getDeliveries);
  const totalDeliveries = useAppSelector(getTotalDeliveries);
  const totalDeliveryAmount = useAppSelector(getTotalDeliveryAmount);
  const items = useAppSelector(getItems);
  const processes = useAppSelector(getProcesses);
  const parties = useAppSelector(getParties);
  const isOrderModalOpen = useAppSelector(getIsOrderModalOpen);
  const editOrder = useAppSelector(getEditOrder);
  const isOrderPhotoModalOpen = useAppSelector(getIsOrderPhotoModalOpen);
  const isDeliveryModalOpen = useAppSelector(getIsDeliveryModalOpen);
  const isDeliveryHistoryModalOpen = useAppSelector(getIsDeliveryHistoryModalOpen);
  const editDelivery = useAppSelector(getEditDelivery);

  const [itemOption, setItemOption] = useState<OptionsProps[]>([]);
  const [processOption, setProcessOption] = useState<OptionsProps[]>([]);
  const [partyOption, setPartyOption] = useState<OptionsProps[]>([]);
  const [statusOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "In Progress",
    },
    {
      value: 1,
      label: "Completed",
    },
  ]);
  const [typeOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "By Order",
    },
    {
      value: 1,
      label: "By Party",
    },
  ]);
  const [pendingOption] = useState<OptionsProps[]>([
    {
      value: 1,
      label: "Yes",
    },
    {
      value: 0,
      label: "No",
    },
  ]);

  interface FilterFormInput {
    name: string;
    fromDate: string;
    toDate: string;
    party_id: number;
    item_id: number;
    process_id: number;
    status: number;
    pending: number;
  }

  interface ExportFormInput {
    fromDate: string;
    toDate: string;
    party_id: number;
    type: number;
    status: number;
    pending: number;
  }

  const { handleSubmit, register, reset, getValues, control, setValue } =
    useForm<FilterFormInput>();

  const {
    handleSubmit: handleSubmit1,
    register: register1,
    reset: reset1,
    control: control1,
    setValue: setValue1,
  } = useForm<ExportFormInput>();

  const {
    handleSubmit: handleSubmit2,
    register: register2,
    reset: reset2,
    control: control2,
    setValue: setValue2,
    getValues: getValues2,
  } = useForm<IInvoiceFilterInput>();

  const [page, setPage] = useState<number>(1);
  const [deliveryPage, setDeliveryPage] = useState<number>(1);
  const [pageSize] = useState<number>(50);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showDeliveries, setShowDeliveries] = useState(false);

  // Invoice generation state
  const [showInvoiceFilter, setShowInvoiceFilter] = useState(false);
  const [invoiceFilterApplied, setInvoiceFilterApplied] = useState(false);
  const [selectedInvoiceOrders, setSelectedInvoiceOrders] = useState<number[]>([]);

  const hanldeGoToHome = () => {
    navigate(route.dashboard);
  };

  const paginate = (pageNumber: number) => {
    setPage(pageNumber);
  };

  const deliveryPaginate = (pageNumber: number) => {
    setDeliveryPage(pageNumber);
  };

  const handleDeleteOrder = async (id: number, password: string) => {
    try {
      await DELETE(`/v1/admin/orders/${id}`, {
        password: password,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const pageNumber = orders.length > 1 ? page : page - 1;
            if (page === pageNumber) {
              fetchOrdersList(page, pageSize);
            } else {
              setPage(pageNumber);
            }

            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleDeleteDelivery = async (id: number, password: string) => {
    try {
      await DELETE(`/v1/admin/deliveries/${id}`, {
        password: password,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const pageNumber = deliveries.length > 1 ? deliveryPage : deliveryPage - 1;
            if (deliveryPage === pageNumber) {
              fetchDeliveriesList(deliveryPage, pageSize);
            } else {
              setDeliveryPage(pageNumber);
            }

            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleOnFilterSubmit = async () => {
    if (showDeliveries) {
      fetchDeliveriesList(deliveryPage, pageSize);
    } else {
      fetchOrdersList(page, pageSize);
    }
  };

  const handleOnExportSubmit = async (data: ExportFormInput) => {
    try {
      const endpoint = showDeliveries ? `/v1/admin/delivery-reports` : `/v1/admin/reports`;
      await GET(endpoint, {
        fromDate: data.fromDate,
        toDate: data.toDate,
        party_id: data.party_id,
        type: data.type,
        status: data.status || data.status === 0 ? data.status : null,
        pending: data.pending ?? null,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });

            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("Pop-up blocked");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleClearFilter = () => {
    reset();
    if (showDeliveries) {
      fetchDeliveriesList(deliveryPage, pageSize);
    } else {
      fetchOrdersList(page, pageSize);
    }
  };

  const handleClearExport = () => {
    reset1();
  };

  const fetchOrdersList = async (page: number, size: number) => {
    const data = getValues();

    setIsLoading(true);

    dispatch(
      fetchOrdersListData({
        page: page,
        size: size,
        search: data?.name || null,
        fromDate: data?.fromDate || null,
        toDate: data?.toDate || null,
        party_id: data?.party_id || null,
        item_id: data?.item_id || null,
        process_id: data?.process_id || null,
        status: data?.status || data?.status === 0 ? data?.status : null,
        pending: data?.pending ?? null,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const fetchInvoiceOrdersList = async (pageNum: number, size: number) => {
    const data = getValues2();
    if (!data.party_id) return;

    setIsLoading(true);

    dispatch(
      fetchOrdersListData({
        page: pageNum,
        size: size,
        search: null,
        fromDate: data.fromDate || null,
        toDate: data.toDate || null,
        party_id: data.party_id,
        item_id: null,
        process_id: null,
        status: 0,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const fetchDeliveriesList = async (page: number, size: number) => {
    const data = getValues();

    setIsLoading(true);

    dispatch(
      fetchDeliveriesListData({
        page: page,
        size: size,
        search: data?.name || null,
        fromDate: data?.fromDate || null,
        toDate: data?.toDate || null,
        party_id: data?.party_id || null,
        item_id: data?.item_id || null,
        process_id: data?.process_id || null,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const handleSaveOrder = async (data: IFormInput) => {
    try {
      if (editOrder) {
        await PUT(`/v1/admin/orders/${editOrder.id}`, {
          ...(data.item_id ? { item_id: data.item_id } : {}),
          process_id: data.process_id,
          qty: data.qty,
          pending: data.pending || 0,
          status: data.status || 0,
          rate: data.rate,
          created_at: moment(data.created_at).format("YYYY-MM-DD H:mm:ss"),
          inch: data.inch || 0,
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(setEditOrder(null));

              fetchOrdersList(page, pageSize);

              toast.success(response.data.message, {
                ...(toastStyles as any),
              });
            } else {
              toast.error(response.data.message, {
                ...(toastStyles as any),
              });
            }
          })
          .catch((error: any) => {
            toast.error(error.data.message, {
              ...(toastStyles as any),
            });
          });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleSaveDelivery = async (data: IDeliveryFormInput) => {
    try {
      if (editDelivery) {
        await PUT(`/v1/admin/deliveries/${editDelivery.id}`, {
          qty: data.qty,
          created_at: moment(data.created_at).format("YYYY-MM-DD H:mm:ss"),
          status: data.status || 0,
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(setEditDelivery(null));

              fetchDeliveriesList(deliveryPage, pageSize);

              toast.success(response.data.message, {
                ...(toastStyles as any),
              });
            } else {
              toast.error(response.data.message, {
                ...(toastStyles as any),
              });
            }
          })
          .catch((error: any) => {
            toast.error(error.data.message, {
              ...(toastStyles as any),
            });
          });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleExportPaymentPdf = async (paymentId: number) => {
    try {
      await GET(`/v1/admin/payments/${paymentId}/reports`, {})
        .then(async (response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });

            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("Pop-up blocked");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        ...(toastStyles as any),
      });
    }
  };

  // Invoice generation handlers
  const handleFetchInvoiceOrders = async (data: IInvoiceFilterInput) => {
    if (!data.party_id) {
      toast.error("Please select a party.", {
        ...(toastStyles as any),
      });
      return;
    }
    setSelectedInvoiceOrders([]);
    setPage(1);
    setInvoiceFilterApplied(true);

    setIsLoading(true);
    dispatch(
      fetchOrdersListData({
        page: 1,
        size: pageSize,
        search: null,
        fromDate: data.fromDate || null,
        toDate: data.toDate || null,
        party_id: data.party_id,
        item_id: null,
        process_id: null,
        status: 0,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const handleToggleInvoiceOrder = (orderId: number) => {
    setSelectedInvoiceOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const handleOpenInvoiceModal = () => {
    if (selectedInvoiceOrders.length === 0) {
      toast.error("Please select at least one order.", {
        ...(toastStyles as any),
      });
      return;
    }
    navigate(route.generateInvoice, {
      state: {
        selectedOrders: selectedOrderObjects,
      },
    });
  };

  const handleClearInvoiceFilter = () => {
    reset2();
    setSelectedInvoiceOrders([]);
    setInvoiceFilterApplied(false);
    setPage(1);
    fetchOrdersList(1, pageSize);
  };

  useEffect(() => {
    if (showDeliveries) {
      fetchDeliveriesList(deliveryPage, pageSize);
    }
  }, [deliveryPage]);

  useEffect(() => {
    if (!showDeliveries) {
      if (invoiceFilterApplied) {
        fetchInvoiceOrdersList(page, pageSize);
      } else {
        fetchOrdersList(page, pageSize);
      }
    }
  }, [page]);

  useEffect(() => {
    if (showDeliveries) {
      setDeliveryPage(1);
      fetchDeliveriesList(1, pageSize);
    } else {
      setPage(1);
      if (invoiceFilterApplied) {
        fetchInvoiceOrdersList(1, pageSize);
      } else {
        fetchOrdersList(1, pageSize);
      }
    }
  }, [showDeliveries]);

  // When invoice filter panel is hidden, reset invoice state and re-fetch normal orders
  useEffect(() => {
    if (!showInvoiceFilter && invoiceFilterApplied) {
      setInvoiceFilterApplied(false);
      setSelectedInvoiceOrders([]);
      reset2();
      setPage(1);
      fetchOrdersList(1, pageSize);
    }
  }, [showInvoiceFilter]);

  useEffect(() => {
    const options =
      items?.map((item) => ({ value: item.id, label: item.name, in_inch: item.in_inch === 1 })) ?? [];
    setItemOption(options);
  }, [items]);

  useEffect(() => {
    const options =
      processes?.map((process) => ({
        value: process.id,
        label: process.name,
      })) ?? [];
    setProcessOption(options);
  }, [processes]);

  useEffect(() => {
    const options =
      parties?.map((party) => ({ value: party.id, label: party.firm_name })) ??
      [];
    setPartyOption(options);
  }, [parties]);

  useEffect(() => {
    dispatch(fetchItemsList());
    dispatch(fetchProcessesList());
    dispatch(fetchPartiesList());
  }, []);

  const selectedOrderObjects = orders.filter((o) =>
    selectedInvoiceOrders.includes(o.id)
  );

  return (
    <Layout>
      <div className={styles.OrdersPage}>
        <div className="logoSection">
          <h1
            onClick={hanldeGoToHome}
            className="text-5xl font-bold text-white lg:text-3xl cursor-pointer lg:w-fit"
          >
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>

        <div className="pageTitleSection">
          <FaArrowLeft
            onClick={hanldeGoToHome}
            className="lg:hidden absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-5xl mt-6 lg:mt-0 font-bold text-white lg:text-2xl lg:text-primary-1">
            {showDeliveries ? "Delivery Details" : "Order Details"}
          </h1>
        </div>

        <div className="mt-[60px] px-4 py-5 lg:px-10">
          <div className="flex flex-col gap-3 mb-4 lg:flex-row lg:justify-between lg:items-center lg:gap-4">
            <div className="flex items-center justify-between gap-4 lg:justify-start">
              <div className="flex rounded-md overflow-hidden border border-primary-1">
                <button
                  className={`px-4 py-2 font-semibold text-sm transition-colors duration-300 ${
                    !showDeliveries
                      ? "bg-gradient-to-r from-primary-1 to-primary-2 text-white"
                      : "bg-white text-primary-1"
                  }`}
                  onClick={() => setShowDeliveries(false)}
                >
                  Orders
                </button>
                <button
                  className={`px-4 py-2 font-semibold text-sm transition-colors duration-300 ${
                    showDeliveries
                      ? "bg-gradient-to-r from-primary-1 to-primary-2 text-white"
                      : "bg-white text-primary-1"
                  }`}
                  onClick={() => setShowDeliveries(true)}
                >
                  Deliveries
                </button>
              </div>

              {!invoiceFilterApplied && (
                <p className="text-primary-1 font-bold text-sm lg:text-base">
                  Total Amount:{" "}
                  {showDeliveries
                    ? totalDeliveryAmount.toFixed(2)
                    : totalAmount.toFixed(2) || 0.0}
                </p>
              )}
            </div>

            <div className="grid grid-cols-3 gap-2 lg:flex lg:gap-4">
              <button
                className="p-2 rounded-md flex items-center justify-center bg-gradient-to-r from-primary-1 to-primary-2 text-white text-xs lg:text-sm transition-colors duration-300"
                onClick={() => {
                  if (!showInvoiceFilter === true) {
                    setShowFilter(false);
                    setShowExport(false);
                  }
                  setShowInvoiceFilter(!showInvoiceFilter);
                }}
              >
                <FaFileInvoice className="mr-1 lg:mr-2 shrink-0" />{" "}
                <span className="whitespace-nowrap">{showInvoiceFilter ? "Hide Invoice" : "Gen. Invoice"}</span>
              </button>

              <button
                className="p-2 rounded-md flex items-center justify-center bg-gradient-to-r from-primary-1 to-primary-2 text-white text-xs lg:text-sm transition-colors duration-300"
                onClick={() => {
                  if (!showExport === true) {
                    setShowFilter(false);
                    setShowInvoiceFilter(false);
                  }
                  setShowExport(!showExport);
                }}
              >
                <FaSearch className="mr-1 lg:mr-2 shrink-0" />{" "}
                <span className="whitespace-nowrap">{showExport ? "Hide Report" : "Show Report"}</span>
              </button>

              <button
                className="p-2 rounded-md flex items-center justify-center bg-gradient-to-r from-primary-1 to-primary-2 text-white text-xs lg:text-sm transition-colors duration-300"
                onClick={() => {
                  if (!showFilter === true) {
                    setShowExport(false);
                    setShowInvoiceFilter(false);
                  }
                  setShowFilter(!showFilter);
                }}
              >
                <FaSearch className="mr-1 lg:mr-2 shrink-0" />{" "}
                <span className="whitespace-nowrap">{showFilter ? "Hide Filter" : "Show Filter"}</span>
              </button>
            </div>
          </div>

          {showInvoiceFilter && (
            <form onSubmit={handleSubmit2(handleFetchInvoiceOrders)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register2("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register2("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-[44px] w-full relative rounded">
                    <Controller
                      {...register2("party_id")}
                      control={control2}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select party name"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue2("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center mt-4">
                  {invoiceFilterApplied ? (
                    <p className="text-primary-1 font-bold">
                      {selectedInvoiceOrders.length} order(s) selected
                    </p>
                  ) : (
                    <div />
                  )}
                  <div className="flex gap-4">
                    <button
                      onClick={handleClearInvoiceFilter}
                      type="button"
                      className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                    >
                      Clear
                    </button>

                    <button
                      type="submit"
                      className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                    >
                      Filter Orders
                    </button>

                    {invoiceFilterApplied && (
                      <button
                        type="button"
                        onClick={handleOpenInvoiceModal}
                        disabled={selectedInvoiceOrders.length === 0}
                        className="px-4 py-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300 disabled:opacity-50"
                      >
                        <FaFileInvoice className="mr-2" /> Generate Invoice
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}

          {showFilter && (
            <form onSubmit={handleSubmit(handleOnFilterSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded p-[2px] h-[44px]">
                    <input
                      {...register("name")}
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded focus:outline-none"
                      placeholder={showDeliveries ? "Search by order ID" : "Search by order ID"}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("party_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select party name"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("item_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            itemOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select item name"}
                          options={itemOption}
                          onChange={(val: any) =>
                            setValue("item_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("process_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            processOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select process name"}
                          options={processOption}
                          onChange={(val: any) =>
                            setValue("process_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  {!showDeliveries && (
                    <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                      <Controller
                        {...register("status")}
                        control={control}
                        render={({ field }) => (
                          <Select
                            isClearable
                            {...field}
                            value={
                              statusOption.find(
                                (val) => val.value === field.value
                              ) || null
                            }
                            className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                            styles={selectStyles}
                            placeholder={"Select status name"}
                            options={statusOption}
                            onChange={(val: any) =>
                              setValue("status", val?.value)
                            }
                          />
                        )}
                      />
                    </div>
                  )}

                  {!showDeliveries && (
                    <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                      <Controller
                        {...register("pending")}
                        control={control}
                        render={({ field }) => (
                          <Select
                            isClearable
                            {...field}
                            value={
                              pendingOption.find(
                                (val) => val.value === field.value
                              ) || null
                            }
                            className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                            styles={selectStyles}
                            placeholder={"Select pending"}
                            options={pendingOption}
                            onChange={(val: any) =>
                              setValue("pending", val?.value)
                            }
                          />
                        )}
                      />
                    </div>
                  )}
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearFilter}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    Clear
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </form>
          )}

          {showExport && (
            <form onSubmit={handleSubmit1(handleOnExportSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("party_id")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select party name"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue1("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("type")}
                      control={control1}
                      defaultValue={0}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            typeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select type"}
                          options={typeOption}
                          onChange={(val: any) => setValue1("type", val?.value)}
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("status")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select status"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue1("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("pending")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            pendingOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"Select pending"}
                          options={pendingOption}
                          onChange={(val: any) =>
                            setValue1("pending", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearExport}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    Clear
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    Generate Report
                  </button>
                </div>
              </div>
            </form>
          )}

          {showDeliveries ? (
            <>
              <DeliveryList
                deliveries={deliveries}
                pageNumber={deliveryPage}
                pageSize={pageSize}
                isLoading={isLoading}
                handleDeleteDelivery={handleDeleteDelivery}
                handleExportPaymentPdf={handleExportPaymentPdf}
              />

              <Pagination
                itemsPerPage={pageSize}
                totalItems={totalDeliveries}
                paginate={deliveryPaginate}
                currentPage={deliveryPage}
              />
            </>
          ) : (
            <>
              <OrderList
                orders={orders}
                pageNumber={page}
                pageSize={pageSize}
                isLoading={isLoading}
                handleDeleteOrder={handleDeleteOrder}
                checkboxesEnabled={invoiceFilterApplied}
                selectedOrderIds={selectedInvoiceOrders}
                onToggleOrder={handleToggleInvoiceOrder}
              />

              <Pagination
                itemsPerPage={pageSize}
                totalItems={totalOrders}
                paginate={paginate}
                currentPage={page}
              />
            </>
          )}

          {isOrderModalOpen === true && (
            <OrdersFormModal handleSaveOrder={handleSaveOrder} />
          )}

          {isDeliveryModalOpen === true && (
            <DeliveryFormModal handleSaveDelivery={handleSaveDelivery} />
          )}

          {isDeliveryHistoryModalOpen === true && (
            <DeliveryHistoryModal handleExportPaymentPdf={handleExportPaymentPdf} />
          )}

          {isOrderPhotoModalOpen !== null && <PhotoModel />}
        </div>
      </div>
    </Layout>
  );
};
export default OrdersPage;
